import React from 'react';
import { IProduct } from '../Library/types';
import PropTypes from 'prop-types';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ListChildComponentProps } from 'react-window';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/ArrowForwardIos';
import MinusIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import CartIcon from '@material-ui/icons/AddShoppingCartOutlined';
import RemoveCartIcon from '@material-ui/icons/RemoveShoppingCartOutlined'
import AddIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { getProductDescriptionColor } from '../Library/helpers';
import TextField from '@material-ui/core/TextField';
import EastIcon from '@material-ui/icons/ArrowForward';

import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Translate from './Material/Traductor';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}
  
const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
}));

const useStyles = makeStyles(createStyles({
    img: {
        objectFit: 'contain',
    },
    root: {
        borderRadius: 0,
    },
    item: {
        // border: '1px solid #ccc',
        borderRadius: '15px',
        margin: '5px 10px',
        width: 'calc(100% - 20px)!important',
        boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.31)',
        cursor: 'pointer',
        paddingBottom: '50px',
        position: 'relative',
    },
    bottomActionsContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '30px',
        borderTop: '1px solid rgba(0,0,0,0.31)',
        borderBottomLeftRadius: '15px',
        borderBottomRightRadius: '15px',
        padding: '5px 0px',
        color: '#284770',
    },
    quantIcon: {
        paddingTop: '3px',
        paddingBottom: '3px',
        color: '#284770',
        verticalAlign: 'middle',
    },
    bottomRightActionsContainer: {
        position: 'absolute',
        right: '0px',
        top: '0px',
        bottom: '0px',
        zIndex: 1,
        fontSize:'12px'
    },
    promotion: {
        //backgroundColor: '#f00',
        display: 'inline-block',
        padding: '5px 0px 5px 0px',
        //color: '#fff',
        verticalAlign: 'middle',
    },
    separator: {
        display: 'inline-block',
        borderRight: '1px solid rgba(0,0,0,0.31)',
        verticalAlign: 'middle',
        height: '100%',
        marginLeft: '15px'
    },
    textField: {
        marginLeft: '10px',
        marginRight: '10px',
        width: 70,
        textAlign: 'center'
    }
}));

const ProductListItem = (props: ListChildComponentProps) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    
    const { index, style, data } = props;
    const classes = useStyles();
    let item: IProduct = data[0];
    let lang: string = data[1];

    let typeProperties : Array<string> = getProductDescriptionColor(item.category_sale, lang);
    //const imageB64 = item.image?new Buffer(item.image).toString("base64"):'';
    
    //imageB64 = `data:image/svg;base64,${imageB64.substring(8,imageB64.length)}`;
    return (
        <Card style={{border:'1px solid #ddd', maxWidth: 250, minWidth:230}}>
            <CardHeader
                avatar={
                <Avatar 
                    id={item.id}
                    sx={{ /*bgcolor: red[500] */ }}
                    aria-label="recipe"
                    alt='' 
                    src={`${item.uri_img}`} 
                    classes={{
                        root: classes.root,
                        img: classes.img
                    }}
                >
                    
                </Avatar>
                }
                action={
                <IconButton aria-label="settings">
                    <MoreVertIcon />
                </IconButton>
                }
                title={item.name}
                subheader={`${item.base_price} ${item.price_unit} (${item.sale_unit/*[0]*/})`}
            />

            <div className={classes.promotion} style={{backgroundColor:typeProperties[1], color:typeProperties[2], width:'100%', textAlign:'center'}}>
                {typeProperties[0]}
            </div>
            <CardActions disableSpacing>
                <div style={{width:'90%', margin:'auto', textAlign:'center'}}>
                    {item.modifiedBySaler?
                            <TextField
                                id="standard-number"
                                disabled
                                value={item.quantityAsked}
                                //defaultValue={item.quantity ? item.quantity : 0}
                                //style={{border:'3px solid #fff', borderRadius:'10px'}}
                                inputProps={{ style: {textAlign: 'center'} }}
                                //onClick={item.onClickManualInput}
                                type="number"
                                className={classes.textField}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                    :
                        null
                    }
                    
                    {item.modifiedBySaler?
                            <IconButton disabled aria-label="settings">
                                <EastIcon />
                            </IconButton>
                    :
                        null
                    }
                    {item.onRemoveUnitClick?
                        <IconButton onClick={item.onRemoveUnitClick} className={classes.quantIcon}>
                            <MinusIcon />
                        </IconButton>
                    :
                        null
                    }

                    <TextField
                        id="standard-number"
                        disabled={!item.onChangeQuantity}
                        value={item.quantity ? item.quantity : item.minimunQuantity}
                        //defaultValue={item.quantity ? item.quantity : 0}
                        //style={{border:'3px solid #fff', borderRadius:'10px'}}
                        onChange={item.onChangeQuantity}
                        inputProps={{ style: {textAlign: 'center'} }}
                        //onClick={item.onClickManualInput}
                        type="number"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {item.onAddUnitClick?
                        <IconButton onClick={item.onAddUnitClick} className={classes.quantIcon}>
                            <AddIcon />
                        </IconButton>
                    :
                        null
                    }
                    {/*<IconButton aria-label="add to favorites">
                    <FavoriteIcon />
                    </IconButton>
                    <IconButton aria-label="share">
                    <ShareIcon />
                </IconButton>*/}
                    {/*<ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    >
                    <ExpandMoreIcon />
                </ExpandMore>*/}
                </div>
            </CardActions>
            <div style={{width:'90%', margin:'auto', textAlign:'center'}}>    
                {item.onRemoveClick?
                    <div style={{display:'block'}}>
                        <button className='button-remove-cart' onClick={()=>item.onRemoveClick(item)}>
                            {Translate(lang, "label.order.06")}
                        </button>
                    </div>   
                :
                    null
                }     
                {/*<div>
                    <div className={classes.separator} />
                    <IconButton onClick={item.updateCart} className={classes.quantIcon}>
                        {item.isInCart === true ? <RemoveCartIcon /> : <CartIcon />}
                    </IconButton>
            </div> */}
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                <Typography paragraph>Method:</Typography>
                <Typography paragraph>
                    Heat 1/2 cup of the broth in a pot until simmering, add saffron and set
                    aside for 10 minutes.
                </Typography>
                <Typography paragraph>
                    Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over
                    medium-high heat. Add chicken, shrimp and chorizo, and cook, stirring
                    occasionally until lightly browned, 6 to 8 minutes. Transfer shrimp to a
                    large plate and set aside, leaving chicken and chorizo in the pan. Add
                    pimentón, bay leaves, garlic, tomatoes, onion, salt and pepper, and cook,
                    stirring often until thickened and fragrant, about 10 minutes. Add
                    saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
                </Typography>
                <Typography paragraph>
                    Add rice and stir very gently to distribute. Top with artichokes and
                    peppers, and cook without stirring, until most of the liquid is absorbed,
                    15 to 18 minutes. Reduce heat to medium-low, add reserved shrimp and
                    mussels, tucking them down into the rice, and cook again without
                    stirring, until mussels have opened and rice is just tender, 5 to 7
                    minutes more. (Discard any mussels that don&apos;t open.)
                </Typography>
                <Typography>
                    Set aside off of the heat to let rest for 10 minutes, and then serve.
                </Typography>
                </CardContent>
            </Collapse>
        </Card>
    );
}

ProductListItem.propTypes = {
    index: PropTypes.number,
    style: PropTypes.object,
} as any;

export default ProductListItem;